export enum Environment {
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
}
